/* ==========================================================================
   Moonou Land: Versand- und Lieferzeit-Hinweise je Lieferland (Österreich)

   Das Land steht schon vor dem ersten Paint am <html> (data-moonou-land), das
   setzt das Inline-Skript aus snippets/moonou-land.liquid. Quelle ist
   localization.country (Shopify Markets), Testhilfe ?moonou_land=AT|DE|aus
   (nur sessionStorage). Alles, was Liquid schon kennt (Warenkorb-Drawer:
   Versandzeile und „Noch X €“), rendert der Server doppelt und CSS blendet je
   Land aus. Diese Datei erledigt den Rest nur für AT:

   - Texte aus Template-JSONs ersetzen (Regeln aus den Theme-Settings),
   - Lieferzeiten (Lieferbalken data-delivery-min/max und Lieferzeit-Sätze) auf
     AT-Werte umrechnen,
   - Weihnachts-Bestellschluss [data-moonou-xmas] auf data-date-at umstellen.

   Für DE passiert nichts außer der kleinen API (window.MoonouLand).
   Der Logik-Kern ist rein und wird in tests/moonou-land.test.cjs geprüft.
   ========================================================================== */
(function (root, factory) {
  var kern = factory();
  if (typeof module === 'object' && module.exports) module.exports = kern;
  if (typeof window !== 'undefined' && typeof document !== 'undefined') kern.start(window, document);
})(typeof self !== 'undefined' ? self : this, function () {
  'use strict';

  var MONATE = ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'];
  var MONATE_KURZ = ['Jan', 'Feb', 'Mär', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez'];
  var TAGE = ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'];
  var TAGE_KURZ = ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'];

  /* ---------- Land ---------- */

  /**
   * Land aus Shopify-Kontext und Testhilfe. Spiegelt das Inline-Skript im Snippet.
   * server: ISO-Code aus localization.country, aktiv: Setting moonou_land_at_aktiv,
   * param: Wert von ?moonou_land, gespeichert: sessionStorage moonou_land.
   * Ergebnis: land (AT|DE), quelle (shopify|test), speichern (AT|DE|null = löschen|undefined = nichts tun).
   */
  function landBestimmen(server, aktiv, param, gespeichert) {
    var land = (aktiv && String(server || '').toUpperCase() === 'AT') ? 'AT' : 'DE';
    var quelle = 'shopify';
    var speichern;
    if (param != null && param !== '') {
      var p = String(param).toUpperCase();
      speichern = (p === 'AT' || p === 'DE') ? p : null;
      gespeichert = speichern;
    }
    if (gespeichert === 'AT' || gespeichert === 'DE') {
      land = gespeichert;
      quelle = 'test';
    }
    return { land: land, quelle: quelle, speichern: speichern };
  }

  /* ---------- Regeln ---------- */

  function platzhalter(text, werte) {
    return String(text).replace(/\[([a-z_]+)\]/g, function (ganz, name) {
      return Object.prototype.hasOwnProperty.call(werte || {}, name) ? werte[name] : ganz;
    });
  }

  /** Zeilen „DE-Text => AT-Text“. Leere Zeilen und Zeilen mit # am Anfang zählen nicht. */
  function regelnLesen(text, werte) {
    var regeln = [];
    String(text || '').split(/\r?\n/).forEach(function (zeile) {
      var z = zeile.trim();
      if (!z || z.charAt(0) === '#') return;
      var pos = z.indexOf('=>');
      if (pos < 1) return;
      var de = z.slice(0, pos).trim();
      var at = platzhalter(z.slice(pos + 2).trim(), werte);
      if (de && de !== at) regeln.push({ de: de, at: at });
    });
    return regeln;
  }

  function escapeRegex(s) {
    return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  /**
   * Ein Durchgang über den Text: an jeder Stelle gewinnt der längste DE-Schlüssel.
   * AT-Texte stehen mit in der Alternation und bleiben stehen, deshalb wird ein
   * schon ersetzter Text (z. B. ein vom Theme geklonter Knoten) nie doppelt ersetzt.
   */
  function ersetzerBauen(regeln) {
    if (!regeln.length) return function (t) { return t; };
    var ziel = {};
    var schutz = {};
    var teile = [];
    regeln.forEach(function (r) {
      if (!Object.prototype.hasOwnProperty.call(ziel, r.de)) { ziel[r.de] = r.at; teile.push(r.de); }
      if (r.at) { schutz[r.at] = true; teile.push(r.at); }
    });
    teile = teile.filter(function (t, i) { return teile.indexOf(t) === i; });
    teile.sort(function (a, b) { return b.length - a.length; });
    var muster = new RegExp(teile.map(escapeRegex).join('|'), 'g');
    return function (text) {
      return String(text).replace(muster, function (treffer) {
        if (schutz[treffer]) return treffer;
        return Object.prototype.hasOwnProperty.call(ziel, treffer) ? ziel[treffer] : treffer;
      });
    };
  }

  /* ---------- Lieferzeit ---------- */

  /** Zeilen „2-4 => 3-5“ zu { '2-4': [3, 5] } */
  function tageLesen(text) {
    var karte = {};
    String(text || '').split(/\r?\n/).forEach(function (zeile) {
      var m = zeile.match(/^\s*(\d+)\s*[-–]\s*(\d+)\s*=>\s*(\d+)\s*[-–]\s*(\d+)\s*$/);
      if (m) karte[(+m[1]) + '-' + (+m[2])] = [+m[3], +m[4]];
    });
    return karte;
  }

  function tageUmrechnen(min, max, karte, plus) {
    var schluessel = min + '-' + max;
    if (karte && Object.prototype.hasOwnProperty.call(karte, schluessel)) return karte[schluessel].slice();
    var p = parseInt(plus, 10) || 0;
    return [min + p, max + p];
  }

  /*
   * Nur Sätze über die gesamte Lieferzeit, keine reinen Produktions- oder
   * DHL-Zeiten: die Zahlen müssen auf „innerhalb von“, „zusammen (aktuell)“
   * oder „In“ folgen und direkt vor „Werktag…“ stehen.
   *   „innerhalb von 2 bis 4 Werktagen bei dir“ (FAQ)
   *   „In 2-4 Werktagen bei dir“ (Warenkorb-Drawer)
   *   „dauern zusammen aktuell <strong>3 bis 5 Werktage</strong>“ (über Knotengrenzen, davor = Text davor)
   * Nicht: „Produktionszeit (3-5 Werktage)“, „weitere 1-2 Werktage“, „innerhalb von 1-3 weiteren Werktagen“.
   */
  var LIEFERZEIT = /(innerhalb von|zusammen(?:\s+aktuell)?|(?:^|[^A-Za-zÄÖÜäöüß])In)(\s+)(\d+)(\s*(?:bis|-|–)\s*)(\d+)(?=\s*Werktag)/g;

  function lieferzeitErsetzen(davor, text, karte, plus) {
    davor = davor || '';
    var ganz = davor + text;
    var stellen = [];
    var m;
    LIEFERZEIT.lastIndex = 0;
    while ((m = LIEFERZEIT.exec(ganz))) {
      var start = m.index + m[1].length + m[2].length;
      if (start < davor.length) continue;
      var neu = tageUmrechnen(+m[3], +m[5], karte, plus);
      stellen.push({ start: start, ende: start + m[3].length + m[4].length + m[5].length, text: neu[0] + m[4] + neu[1] });
    }
    for (var i = stellen.length - 1; i >= 0; i--) {
      ganz = ganz.slice(0, stellen[i].start) + stellen[i].text + ganz.slice(stellen[i].ende);
    }
    return ganz.slice(davor.length);
  }

  /**
   * Wert aus der Merkmal-Tabelle („Lieferzeit: 2-4 Werktage“, Metafeld custom.delivery_time):
   * die erste Spanne umrechnen, Schreibweise bleibt (2-4, 2 bis 4).
   */
  function lieferzeitWert(text, karte, plus) {
    var m = String(text).match(/(\d+)(\s*(?:bis|-|–)\s*)(\d+)/);
    if (!m) return text;
    var neu = tageUmrechnen(+m[1], +m[3], karte, plus);
    return String(text).replace(m[0], neu[0] + m[2] + neu[1]);
  }

  /* ---------- Datum für den Weihnachts-Bestellschluss ---------- */

  function isoTeile(iso) {
    var m = String(iso || '').match(/^(\d{4})-(\d{2})-(\d{2})$/);
    if (!m) return null;
    var d = new Date(Date.UTC(+m[1], +m[2] - 1, +m[3]));
    return { j: +m[1], m: +m[2], t: +m[3], iso: m[0], wt: d.getUTCDay() };
  }

  function wieVorlage(vorlage, zahl) {
    var s = String(zahl);
    return (vorlage.length === 2 && s.length === 1) ? '0' + s : s;
  }

  /**
   * Ersetzt das DE-Datum im Text durch das AT-Datum, in den Formen 17.12.2026,
   * 17.12.26, 17.12., 17.12, 17. Dezember (2026), 17. Dez., 2026-12-17. Steht ein
   * Datum im Text, wird auch der Wochentag umgestellt (Donnerstag/Do → Dienstag/Di).
   */
  function xmasText(text, deIso, atIso) {
    var de = isoTeile(deIso), at = isoTeile(atIso);
    if (!de || !at || de.iso === at.iso) return text;
    var neu = String(text);
    var vorher = neu;

    neu = neu.split(de.iso).join(at.iso);

    var zahl = new RegExp('(^|[^\\d.])(0?' + de.t + ')\\.(\\s?)(0?' + de.m + ')(?:(\\.)(\\d{4}|\\d{2})?)?(?![\\d])', 'g');
    neu = neu.replace(zahl, function (g, vor, t, raum, mo, punkt, jahr) {
      var aus = vor + wieVorlage(t, at.t) + '.' + raum + wieVorlage(mo, at.m);
      if (punkt) aus += '.';
      if (jahr) aus += jahr.length === 2 ? String(at.j).slice(2) : String(at.j);
      return aus;
    });

    var name = new RegExp('(^|[^\\d])(0?' + de.t + ')\\.(\\s?)(' + escapeRegex(MONATE[de.m - 1]) + '|' + escapeRegex(MONATE_KURZ[de.m - 1]) + '\\.?)(\\s+' + de.j + ')?', 'g');
    neu = neu.replace(name, function (g, vor, t, raum, monat, jahr) {
      var lang = monat === MONATE[de.m - 1];
      var aus = vor + wieVorlage(t, at.t) + '.' + raum;
      aus += lang ? MONATE[at.m - 1] : MONATE_KURZ[at.m - 1] + (monat.slice(-1) === '.' ? '.' : '');
      if (jahr) aus += jahr.replace(String(de.j), String(at.j));
      return aus;
    });

    if (neu !== vorher && de.wt !== at.wt) {
      neu = neu.replace(new RegExp('(^|[^A-Za-zÄÖÜäöüß])' + TAGE[de.wt] + '(?![A-Za-zäöüß])', 'g'), '$1' + TAGE[at.wt]);
      neu = neu.replace(new RegExp('(^|[^A-Za-zÄÖÜäöüß])' + TAGE_KURZ[de.wt] + '(?=[.,\\s])', 'g'), '$1' + TAGE_KURZ[at.wt]);
    }
    return neu;
  }

  /** Attributwerte (z. B. data-expires="2026-12-17T23:59:59+01:00"): nur das ISO-Datum tauschen. */
  function xmasAttribut(wert, deIso, atIso) {
    if (!wert || !deIso || !atIso) return wert;
    return String(wert).split(deIso).join(atIso);
  }

  /* ---------- Hilfen ---------- */

  function kurzHash(s) {
    var h = 5381;
    s = String(s);
    for (var i = 0; i < s.length; i++) h = ((h << 5) + h + s.charCodeAt(i)) | 0;
    return (h >>> 0).toString(36);
  }

  function tageAddieren(start, tage, werktage) {
    var d = new Date(start);
    if (!werktage) { d.setDate(d.getDate() + tage); return d; }
    var dazu = 0;
    while (dazu < tage) {
      d.setDate(d.getDate() + 1);
      var wt = d.getDay();
      if (wt !== 0 && wt !== 6) dazu++;
    }
    return d;
  }

  function zweistellig(n) { return n < 10 ? '0' + n : '' + n; }

  /** Gleiches Format wie assets/moonou-buybox.js: „DD.MM - DD.MM“ */
  function lieferdatum(jetzt, min, max, werktage) {
    var a = tageAddieren(jetzt, min, werktage), b = tageAddieren(jetzt, max, werktage);
    return zweistellig(a.getDate()) + '.' + zweistellig(a.getMonth() + 1) + ' - ' + zweistellig(b.getDate()) + '.' + zweistellig(b.getMonth() + 1);
  }

  /* ---------- DOM (nur Browser) ---------- */

  var UEBERSPRINGEN = { SCRIPT: 1, STYLE: 1, NOSCRIPT: 1, TEXTAREA: 1, TEMPLATE: 1, INPUT: 1, SELECT: 1, OPTION: 1, CODE: 1, PRE: 1 };
  var ABSATZ_SELEKTOR = 'p, li, dd, td, h1, h2, h3, h4, h5, h6';
  var ATTR_TEXT = 'data-moonou-land-text';
  var ATTR_ABSATZ = 'data-moonou-land-absatz';
  var ATTR_TAGE = 'data-moonou-land-tage';
  var ATTR_XMAS = 'data-moonou-xmas-land';

  function start(win, doc) {
    var api = win.MoonouLand = win.MoonouLand || {};
    var konfig = {};
    try {
      var knoten = doc.getElementById('moonou-land-config');
      if (knoten) konfig = JSON.parse(knoten.textContent || '{}');
    } catch (e) { konfig = {}; }

    var land = api.land || doc.documentElement.getAttribute('data-moonou-land') || 'DE';
    var istAT = land === 'AT';
    var karte = tageLesen(konfig.lieferzeit);
    var plus = konfig.lieferzeitPlus;
    var werte = konfig.werte || {};
    var immer = ersetzerBauen(regelnLesen(konfig.texte, werte));
    var unter = ersetzerBauen(regelnLesen(konfig.texteUnterSchwelle, werte));
    var absaetze = regelnLesen(konfig.absaetze, werte);
    var seitenPreis = (typeof konfig.seitenPreis === 'number') ? konfig.seitenPreis : null;
    var schwelleCent = konfig.schwelleCent || 12500;
    var nachPreis = [];
    var original = typeof WeakMap === 'function' ? new WeakMap() : null;

    function unterSchwelle() { return seitenPreis === null || seitenPreis < schwelleCent; }

    api.land = land;
    api.istAT = istAT;
    api.konfig = konfig;
    api.lieferzeit = function (min, max) { return istAT ? tageUmrechnen(min, max, karte, plus) : [min, max]; };
    api.xmasDatum = function (el) {
      if (!el) return '';
      return (istAT && el.getAttribute('data-date-at')) || el.getAttribute('data-date-de') || '';
    };
    api.test = function (wert) {
      try {
        if (wert === 'AT' || wert === 'DE') win.sessionStorage.setItem('moonou_land', wert);
        else win.sessionStorage.removeItem('moonou_land');
      } catch (e) { /* privates Fenster */ }
      win.location.reload();
    };

    if (!istAT) {
      melden();
      return;
    }

    /* Text davor (für Zahlen in <strong> hinter „zusammen aktuell“) */
    function textDavor(node) {
      var n = node.previousSibling;
      if (!n && node.parentNode && node.parentNode.previousSibling && /^(STRONG|B|EM|I|SPAN)$/.test(node.parentNode.nodeName)) {
        n = node.parentNode.previousSibling;
      }
      return n ? String(n.textContent || '').slice(-40) : '';
    }

    function verwandeln(de, node) {
      var aus = immer(de);
      if (unterSchwelle()) aus = unter(aus);
      return lieferzeitErsetzen(textDavor(node), aus, karte, plus);
    }

    function merke(eltern, text) {
      var liste = (eltern.getAttribute(ATTR_TEXT) || '').split(' ').filter(Boolean);
      var h = kurzHash(text);
      if (liste.indexOf(h) === -1) {
        liste.push(h);
        if (liste.length > 12) liste = liste.slice(-12);
        eltern.setAttribute(ATTR_TEXT, liste.join(' '));
      }
    }

    function textknoten(node) {
      var eltern = node.parentNode;
      if (!eltern || eltern.nodeType !== 1) return;
      var wert = node.nodeValue;
      if (!wert || !/\S/.test(wert)) return;
      var liste = eltern.getAttribute(ATTR_TEXT);
      if (liste && liste.split(' ').indexOf(kurzHash(wert)) !== -1) return;
      var aus = verwandeln(wert, node);
      /* Preisabhängige Texte immer merken, auch wenn sie beim Laden (Variante ab der
         Schwelle) unverändert bleiben: ein Wechsel auf eine günstigere Variante muss sie
         noch ersetzen können. */
      if (original && immer(wert) !== unter(immer(wert))) {
        original.set(node, wert);
        if (nachPreis.indexOf(node) === -1) nachPreis.push(node);
      }
      if (aus === wert) return;
      node.nodeValue = aus;
      merke(eltern, aus);
      if (original && !original.has(node)) original.set(node, wert);
    }

    function ueberspringen(el) {
      for (var e = el; e && e.nodeType === 1; e = e.parentNode) {
        if (UEBERSPRINGEN[e.nodeName] || e.isContentEditable) return true;
        if (e.hasAttribute('data-moonou-land-ignorieren') || e.hasAttribute(ATTR_ABSATZ)) return true;
      }
      return false;
    }

    function alleTexte(wurzel) {
      if (wurzel.nodeType === 3) {
        if (!ueberspringen(wurzel.parentNode)) textknoten(wurzel);
        return;
      }
      if (wurzel.nodeType !== 1 || ueberspringen(wurzel)) return;
      var gehen = doc.createTreeWalker(wurzel, 4, {
        acceptNode: function (n) { return ueberspringen(n.parentNode) ? 2 : 1; }
      });
      var liste = [];
      while (gehen.nextNode()) liste.push(gehen.currentNode);
      liste.forEach(textknoten);
    }

    function innen(wurzel, selektor) {
      var treffer = [];
      if (wurzel.nodeType !== 1) return treffer;
      if (wurzel.matches && wurzel.matches(selektor)) treffer.push(wurzel);
      var unten = wurzel.querySelectorAll(selektor);
      for (var i = 0; i < unten.length; i++) treffer.push(unten[i]);
      return treffer;
    }

    function absaetzeErsetzen(wurzel) {
      if (!absaetze.length) return;
      innen(wurzel, ABSATZ_SELEKTOR).forEach(function (el) {
        if (el.hasAttribute(ATTR_ABSATZ) || ueberspringen(el.parentNode)) return;
        var text = el.textContent || '';
        for (var i = 0; i < absaetze.length; i++) {
          if (text.indexOf(absaetze[i].de) !== -1) {
            el.setAttribute(ATTR_ABSATZ, '');
            /* HTML aus dem Theme-Setting moonou_land_at_absaetze (vom Shop gepflegt, wie Richtext) */
            el.innerHTML = absaetze[i].at;
            return;
          }
        }
      });
    }

    function lieferbalken(wurzel) {
      innen(wurzel, '[data-delivery-min][data-delivery-max]').forEach(function (el) {
        if (el.hasAttribute(ATTR_TAGE)) return;
        var min = parseInt(el.getAttribute('data-delivery-min'), 10);
        var max = parseInt(el.getAttribute('data-delivery-max'), 10);
        if (isNaN(min) || isNaN(max)) return;
        var neu = tageUmrechnen(min, max, karte, plus);
        el.setAttribute(ATTR_TAGE, min + '-' + max);
        el.setAttribute('data-delivery-min', neu[0]);
        el.setAttribute('data-delivery-max', neu[1]);
        var ziel = el.querySelector('[data-delivery-dates]');
        if (ziel && /\d/.test(ziel.textContent || '')) {
          ziel.textContent = lieferdatum(new Date(), neu[0], neu[1], el.hasAttribute('data-delivery-business-days'));
        }
      });
    }

    /* Merkmal-Tabelle der Produktseite (snippets/moonou-pd-attrs.liquid), Zeile „Lieferzeit“ */
    function merkmalLieferzeit(wurzel) {
      var zeilen = innen(wurzel, '.moonou-pd__attr');
      var el = wurzel.nodeType === 1 ? wurzel : wurzel.parentNode;
      var zeile = el && el.closest ? el.closest('.moonou-pd__attr') : null;
      if (zeile && zeilen.indexOf(zeile) === -1) zeilen.push(zeile);
      zeilen.forEach(function (z) {
        var label = z.querySelector('.moonou-pd__attr-label');
        var wert = z.querySelector('.moonou-pd__attr-value');
        if (!label || !wert || wert.hasAttribute(ATTR_TAGE)) return;
        if (!/^\s*Lieferzeit\s*:?\s*$/i.test(label.textContent || '')) return;
        var vorher = wert.textContent || '';
        if (!/\d\s*(?:bis|-|–)\s*\d/.test(vorher)) return;
        wert.setAttribute(ATTR_TAGE, vorher.trim());
        var gehen = doc.createTreeWalker(wert, 4, null);
        while (gehen.nextNode()) {
          var n = gehen.currentNode;
          var neu = lieferzeitWert(n.nodeValue, karte, plus);
          if (neu !== n.nodeValue) { n.nodeValue = neu; return; }
        }
      });
    }

    /* Datum, Attribute und Texte auf AT stellen. Wiederholbar (ersetzt nur das DE-Datum),
       deshalb auch während des Parsens nutzbar, wenn der Inhalt noch nicht komplett ist. */
    function xmasStellen(el) {
      var de = el.getAttribute('data-date-de');
      var at = el.getAttribute('data-date-at');
      if (!at) return false;
      if (el.getAttribute('data-date') !== at) el.setAttribute('data-date', at);
      if (de && de !== at) {
        [el].concat(Array.prototype.slice.call(el.querySelectorAll('*'))).forEach(function (e) {
          for (var i = 0; i < e.attributes.length; i++) {
            var a = e.attributes[i];
            if (a.name === 'data-date-de' || a.name === 'data-date-at') continue;
            if (a.value.indexOf(de) !== -1) e.setAttribute(a.name, xmasAttribut(a.value, de, at));
          }
        });
        var gehen = doc.createTreeWalker(el, 4, null);
        var liste = [];
        while (gehen.nextNode()) liste.push(gehen.currentNode);
        liste.forEach(function (n) {
          var neu = xmasText(n.nodeValue, de, at);
          if (neu !== n.nodeValue) n.nodeValue = neu;
        });
      }
      return true;
    }

    function xmas(wurzel) {
      innen(wurzel, '[data-moonou-xmas]').forEach(function (el) {
        if (el.getAttribute(ATTR_XMAS) === 'AT') return;
        if (!xmasStellen(el)) return;
        var at = el.getAttribute('data-date-at');
        var de = el.getAttribute('data-date-de');
        el.setAttribute(ATTR_XMAS, 'AT');
        el.dispatchEvent(new CustomEvent('moonou:land-xmas', { bubbles: true, detail: { land: 'AT', datum: at, de: de } }));
      });
    }

    function verarbeiten(wurzel) {
      if (!wurzel) return;
      try {
        xmas(wurzel);
        lieferbalken(wurzel);
        merkmalLieferzeit(wurzel);
        absaetzeErsetzen(wurzel);
        alleTexte(wurzel);
      } catch (e) {
        if (win.console) win.console.warn('[moonou-land]', e);
      }
    }

    /* Preisgrenze: bei Variantenwechsel neu bewerten (z. B. inkl. Versand ab Schwelle) */
    function preisNeu(cent) {
      if (typeof cent !== 'number' || cent === seitenPreis) return;
      seitenPreis = cent;
      nachPreis = nachPreis.filter(function (n) { return n.isConnected; });
      nachPreis.forEach(function (n) {
        var de = original && original.get(n);
        if (de == null) return;
        var aus = verwandeln(de, n);
        if (aus !== n.nodeValue) {
          n.nodeValue = aus;
          if (n.parentNode && n.parentNode.nodeType === 1) merke(n.parentNode, aus);
        }
      });
    }
    doc.addEventListener('variant:change', function (e) {
      var v = e && e.detail && e.detail.variant;
      if (v && typeof v.price === 'number') preisNeu(v.price);
    }, true);

    /* Früh-Modus: Für echte AT-Besucher lädt das Snippet diese Datei ohne defer im <head>.
       Dann ersetzt der MutationObserver Texte, Lieferzeiten und Bestellschluss schon,
       während der Parser die Seite aufbaut, also vor dem ersten Paint (kein Flackern).
       Absätze werden erst bei DOMContentLoaded ersetzt, weil ihr Inhalt beim Einfügen
       noch unvollständig sein kann; danach läuft einmal der volle Durchgang. */
    var frueh = doc.readyState === 'loading';

    function fruehVerarbeiten(n) {
      try {
        var el = n.nodeType === 1 ? n : n.parentNode;
        var box = el && el.nodeType === 1 && el.closest ? el.closest('[data-moonou-xmas]') : null;
        if (box) xmasStellen(box);
        innen(n, '[data-moonou-xmas]').forEach(xmasStellen);
        lieferbalken(n);
        merkmalLieferzeit(n);
        alleTexte(n);
      } catch (e) {
        if (win.console) win.console.warn('[moonou-land]', e);
      }
    }

    api.verarbeiten = verarbeiten;
    if (frueh) {
      doc.addEventListener('DOMContentLoaded', function () {
        frueh = false;
        verarbeiten(doc.body);
      });
    } else {
      verarbeiten(doc.body || doc.documentElement);
    }

    if (typeof MutationObserver === 'function') {
      var offen = [];
      var geplant = false;
      var beobachter = new MutationObserver(function (eintraege) {
        eintraege.forEach(function (e) {
          for (var i = 0; i < e.addedNodes.length; i++) offen.push(e.addedNodes[i]);
        });
        if (geplant || !offen.length) return;
        geplant = true;
        (win.queueMicrotask || function (f) { win.setTimeout(f, 0); })(function () {
          geplant = false;
          var jetzt = offen;
          offen = [];
          /* Knoten, deren Vorfahr im selben Stapel steckt, deckt der Vorfahr schon ab */
          var stapel = typeof Set === 'function' ? new Set(jetzt) : null;
          jetzt.forEach(function (n) {
            if (!n.isConnected) return;
            if (stapel) {
              for (var p = n.parentNode; p; p = p.parentNode) if (stapel.has(p)) return;
            }
            if (frueh) fruehVerarbeiten(n);
            else verarbeiten(n);
          });
        });
      });
      beobachter.observe(doc.documentElement, { childList: true, subtree: true });
    }

    melden();

    function melden() {
      try {
        doc.dispatchEvent(new CustomEvent('moonou:land', { detail: { land: land, quelle: api.quelle || 'shopify' } }));
      } catch (e) { /* alte Browser */ }
    }
  }

  return {
    landBestimmen: landBestimmen,
    platzhalter: platzhalter,
    regelnLesen: regelnLesen,
    ersetzerBauen: ersetzerBauen,
    tageLesen: tageLesen,
    tageUmrechnen: tageUmrechnen,
    lieferzeitErsetzen: lieferzeitErsetzen,
    lieferzeitWert: lieferzeitWert,
    xmasText: xmasText,
    xmasAttribut: xmasAttribut,
    lieferdatum: lieferdatum,
    kurzHash: kurzHash,
    start: start
  };
});
